import { FC } from "react";
import cx from "classnames";

// import useCollaboration from "./../../../hooks/useCollaboration";
import { useUser } from "../../../hooks/useUser";
import Button, { ButtonVariant } from "../../../libs/Button";
// import { IconTypes } from "../../../libs/Icon";
import useShallowSelector from "../../../hooks/useShalowSelector";
import usePopup from "../../../hooks/usePopup";
import { PopupTypes } from "../../../store/types/Popup";
import { getActiveRoute } from "../../../helpers/getActiveRoute";
import { useLocation } from "react-router-dom";
import { RouteType } from "../../routes/types";

import styles from "./styles.module.scss";

interface IProps {}

const UserActions: FC<IProps> = () => {
    // const { isOpen: isCollaborationOpen, onToggle: onCollaborationToggle } = useCollaboration();
    const location = useLocation();
    const { isOpen: isUserOptionsOpen, onToggle: onUserOptionsToggle } = useUser();
    const { onOpen: onPopupOpen } = usePopup();
    const activeRoute = getActiveRoute(location.pathname);

    const userData = useShallowSelector(state => state.auth.user);
    const { name: userName = "", pic: userPic = "" } = userData || {};
    const nameFirstLetters = userName
        ? userName
              .split(" ")
              .map(part => part[0])
              .join("")
              .slice(0, 2)
        : "";

    return (
        <div className={styles.wrapper}>
            {/* <Button
                icon={IconTypes.ADD_COLLABORATOR}
                iconSize={26}
                onClick={onCollaborationToggle}
                className={cx(styles.btn, { [styles.active]: isCollaborationOpen })}
            /> */}
            {activeRoute === RouteType.Preview && (
                <Button onClick={() => onPopupOpen(PopupTypes.SHARE)} className={styles.btnShare} text="Share" />
            )}
            <Button
                variant={ButtonVariant.PAPER}
                className={cx(styles.userBtn, { [styles.active]: isUserOptionsOpen })}
                text={userPic ? <img src={userPic} alt="User Avatar" className={styles.userPic} /> : nameFirstLetters}
                onClick={onUserOptionsToggle}
            />
        </div>
    );
};

export default UserActions;
